<div class="container">
        <div class="row no-gutters">
          <div class="col-12">
            <div class="d-flex popup-head align-items-center">
              <div class="popup-title mr-auto" translate>lblAddVersion</div>
              <div class="float-right">
                <a class="close mr-3" (click)="OnClose()" translate>
                  <span class="" aria-hidden="true">&times;</span>
                  </a>
              </div>
              
            </div>
            <div *ngIf="addApplicationVersionForm">
            <form [formGroup]="addApplicationVersionForm" (ngSubmit)="addApplicationVersion()">
              <div class="scrollbar">
                <div class="card-content">
                  <div class="card-body p-0">
                    <div class="row">

                      <div class="col-12 af-form-group">
                        <label for="versionNumber" translate>lblVersionNumber
                          <strong class="mlt6 required"> * </strong>
                        </label>
                        <div class='lbl-info'>
                          <input formControlName="versionNumber" class="form-control mb-2" [ngClass]="{'is-invalid': cpf.versionNumber.invalid}"
                            maxlength="50">
                        </div>
                      </div>

                      <div class="col-12 af-form-group mt-2">
                        <div class="d-flex align-items-center">
                          <label class="text mb-0" for="releaseNote" translate>lblReleaseNote
                            <strong class="mlt6 required"> * </strong>
                          </label>
                          <div *ngIf="cpf.releaseNote.touched && (cpf.releaseNote.errors?.required)" class="help-block ml-3 text-danger"
                            translate>
                            <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                            lblReleaseNoteRequired
                          </div>
                        </div>
                        <quill-editor format="html" formControlName="releaseNote" [modules]="options" required></quill-editor>
                      </div>

                      <div class="col-12 af-form-group mt-2">
                        <div class="d-flex align-items-center">
                          <label class="text mb-0" for="internalReleaseNote" translate>lblInternalReleaseNote
                            <strong class="mlt6 required"> * </strong>
                          </label>
                          <div *ngIf="cpf.internalReleaseNote.touched && (cpf.internalReleaseNote.errors?.required)" class="help-block ml-3 text-danger"
                            translate>
                            <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                            lblInternalReleaseNoteRequired
                          </div>
                        </div>
                        <quill-editor format="html" formControlName="internalReleaseNote" [modules]="options" required></quill-editor>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="p-3 bg-light pp-footer-top-brdr">
                <div class="d-flex flex-sm-row flex-column justify-content-end">
                  <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!addApplicationVersionForm.valid"
                    translate><em class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
                  <a  (click)="OnClose()" class="btn btn-secondary btn-lg" translate>
                    <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                </div>
              </div>
            </form>
        </div>
          </div>
        </div>
      </div>